import { styled } from '@clickcease/cc-client-components-lib'
import * as RadioGroup from '@radix-ui/react-radio-group'

export const RadioGroupRoot = styled(RadioGroup.Root, {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '$12',
  marginBottom: '$12',

  '> :first-child': {
    marginBottom: '$8',
  },
})

export const RadioGroupItem = styled(RadioGroup.Item, {
  all: 'unset',
  backgroundColor: 'white',
  width: '16px',
  height: '16px',
  marginTop: '3px',
  border: '1px solid $disabled',
  borderRadius: '100%',
  cursor: 'pointer',
  '&:hover': { border: '1px solid $primaryColor' },
  '&:focus': { border: '1px solid $primaryColor' },

  '&[data-state="checked"]': {
    border: '1px solid $primaryColor',
  },
})

export const RadioGroupIndicator = styled(RadioGroup.Indicator, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  position: 'relative',
  '&::after': {
    content: '""',
    display: 'block',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '$primaryColor',
  },
})

export const OptionContainer = styled('div', {
  display: 'flex',
  width: '100%',
  cursor: 'pointer',
})

export const AnnotationContainer = styled('label', {
  all: 'unset',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  marginLeft: '$4',

  '> :first-child': {
    marginBottom: '$2',
  },

  variants: {
    isFeatureEnabled: {
      true: {
        width: '780px',
      },
      false: {
        width: '405px',
      },
    },
  },
})

export const ToastContainer = styled('div', {})
